import React from "react";
import { Box } from "@mui/material";
import { stepsConfig } from "../step-config";
import { groupsConfig, getGroupIndex } from "../group-config";
import { useStepCompletion } from "../hooks/useStepCompletion";
import "./StepHeader.css";

type Props = {
  activeIndex: number;
};

export default function StepHeader({ activeIndex }: Props) {
  const completions = useStepCompletion();
  
  // Get the current active step ID
  const activeStepId = stepsConfig[activeIndex]?.id;
  const activeGroupIndex = getGroupIndex(activeStepId);

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto" }}>
      <div className="onb-steps">
        {groupsConfig.map((group, groupIdx) => {
          // Check if ALL required (non-optional) steps in this group are completed
          const allStepsCompleted = group.steps.every((stepId) => {
            const status = completions[stepId as keyof typeof completions];
            // Optional steps don't need to be completed for group to be complete
            if (status?.isOptional) {
              return true;
            }
            return status?.isCompleted || false;
          });
          
          // Check if this group is currently active (contains the active step)
          const isActiveGroup = groupIdx === activeGroupIndex;
          
          // Show checkmark if all steps completed and not currently in this group
          const showCheckmark = allStepsCompleted && !isActiveGroup;
          
          // Group is completed if all its steps are completed
          const isCompleted = allStepsCompleted;
          
          // Check if this group is before the active group
          const isBeforeActive = groupIdx < activeGroupIndex;
          
          return (
            <div 
              key={group.id} 
              className={`onb-step ${isCompleted ? 'completed' : ''} ${isActiveGroup ? 'active' : ''}`}
            >
              <div className={`onb-line ${isBeforeActive && isCompleted ? 'completed-line' : ''}`} />
              <div className="onb-dot">
                {showCheckmark ? '✓' : groupIdx + 1}
              </div>
              <div className="onb-label">{group.title}</div>
            </div>
          );
        })}
      </div>
    </Box>
  );
}


